"use client"

import DonorPortalNavBar from '../../components/dpnavbar';
import DonorPortalFooter from '../../components/dpfooter';
import { Providers, figtree } from './providers';
import { ComponentType, use } from "react";
import './globals.css';
import { withLDProvider } from "launchdarkly-react-client-sdk";
import { GoogleTagManager } from "@next/third-parties/google";
import MyKEXPCard from "../../components/mykexpcard";
import { usePathname } from 'next/navigation';
import LandingPageCard from '@/components/landingpagecard';

function RootLayout({
  params,
  children,
}: {
  params: Promise<{
    lang: string
  }>,
  children: React.ReactNode
}) {

  const { lang } = use(params);
  const path: string = usePathname()
  const enableKEXPCard = path.includes( "/recent-giving" );
  const enableHeroBackground = path.includes( "/login" ) || path.includes( "/signup" ) || path.includes( "/authenticated-user-signup" );
  const enableLandingPageCard = path === ( "/" + lang );

  return (

    <html lang="en" className="kexp-mode" data-theme="kexp-mode">
      <GoogleTagManager gtmId="GTM-57VG3W" />
      <body className={figtree.className}>
        <Providers params={{ lang }}>
          <DonorPortalNavBar />
          { enableLandingPageCard &&
            <LandingPageCard locale={lang}/>
          }
          { enableKEXPCard &&
            <MyKEXPCard />
          }
          <div className={"px-4 sm:px-32 md:px-48 lg:px-72 xl:px-96" + (enableHeroBackground ? " bg-kexp-hero-background bg-center text-white" : " bg-kexp-light-layout-background text-black")}>
            {children}
          </div>
          <DonorPortalFooter />
        </Providers>
      </body>
    </html>
  );
}

export default withLDProvider({
  clientSideID: process.env.NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_ID as string,
  deferInitialization: false,
  options: {
      streaming: false,
  },
  reactOptions: {
      useCamelCaseFlagKeys: false,
  }
})(RootLayout as ComponentType<object>) as unknown as ComponentType<{ params: Promise<{ lang: string }>, children: React.ReactNode }>;

